









































import { Component, Mixins, Watch } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CustomForm from '@/components/custom-form/index.vue'
import TreeSelect from '@/components/tree-select/index.vue'
import NavSetApi from '@/api/shopMall/navSet'
import SelectUrl from '../../floorSet/components/selectUrl.vue'

const defaultParentId = '-1'

@Component({
  components: {
    CustomForm,
    TreeSelect,
    SelectUrl
  }
})
export default class GoodsCategoryEdit extends AbpBase {
  parentId: any = JSON.stringify({ value: defaultParentId })
  categorys: any[] = [
    {
      value: defaultParentId,
      label: '顶级导航',
      children: []
    }
  ]
  tempList: any[] = []
  filters = [
    {
      label: '导航名称：',
      type: 'input',
      rule: { required: true, message: '请输入导航名称', trigger: 'blur' },
      key: 'name'
    },
    {
      label: '排序：',
      type: 'input-number',
      key: 'displayOrder',
      props: {
        min: 0
      }
    }
  ]
  editId: any = null
  link = ''
  mounted() {
    if (this.$route.params['id']) {
      this.editId = this.$route.params['id']
      this.getData()
    }
    this.getCategoryTree()
  }

  urlChange(e) {
    this.link = e
  }

  selectChange(parent) {
    console.log(parent)
    // const { value } = JSON.parse(parent)
    // const { tempList } = this

    // for (let i = 0, len = tempList.length; i < len; i++) {
    //   const nowItem = tempList[i]
    //   if (nowItem.value === value) {

    //   }
    // }
  }

  onSubmit(form, valid) {
    if (valid) {
      let { parentId, editId } = this
      let parent = JSON.parse(parentId)

      let obj: any = {
        parentId: parent.value === defaultParentId ? null : parent.value,
        link: this.link
      }
      let { displayOrder, name } = form
      Object.assign(obj, { displayOrder, name })
      NavSetApi.edit(editId, obj).then(res => {
        this.$Message.success(editId ? '修改成功' : '添加成功')
        this.$router.push({ name: 'pcNavSet', replace: true })
      })
    }
  }

  getData() {
    if (!this.editId) {
      return
    }
    NavSetApi.getDataById(this.editId).then(res => {
      let { displayOrder, parentId, name, link } = res.data
      this.link = link
      this.parentId = JSON.stringify({ value: parentId || defaultParentId })
      ;(this.$refs.formEdit as any).setForm({
        displayOrder,
        name
      })
    })
  }

  flatten(arr) {
    var res = []
    arr.map(item => {
      res.push(item)
      if (item.children && item.children.length) {
        res = res.concat(this.flatten(item.children))
      }
    })
    return res
  }

  getCategoryTree() {
    NavSetApi.getTreeData().then(res => {
      let list = JSON.stringify(res.data)
      list = list.replace(/"name":/g, '"label":')
      list = list.replace(/"id":/g, '"value":')
      this.tempList = this.flatten(JSON.parse(list))
      this.categorys = [
        {
          value: defaultParentId,
          label: '顶级导航',
          children: JSON.parse(list)
        }
      ]
    })
  }
}
